import { OrgTypeEnum } from "~/typings/types";

export const getTitleFieldCrmPhoneByOrgType = (orgType: OrgTypeEnum, title?: string) => {
  if (orgType === OrgTypeEnum.IndividualEntrepreneur) {
    return title + ' ИП';
  }

  if (orgType === OrgTypeEnum.SelfEmployed) {
    return title + ' СМЗ';
  }

  if (orgType === OrgTypeEnum.Company) {
    return title + ' Юр. лица';
  }

  return title;
};
